module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAj0lEQVR42u3aMQqAMAxA0ZzF0dV7ejkPFBeHDApSHcS8wJ9b3lJKG5kZnQsAAAAAAAAAAAAAAJoDxLLmSHW2aT6tzug6bwcAAAAAAAAAAAAAAAAAAI4ezx2ADw0AABXgavN/DQAAAAAAOAYBAHAZAgAAAAAAAAAAAAAAAIDuL0N+igIAAAAAAAAAAAAA0KcdKIVQ8FKbABkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Iceland.png
// module id = HS+z
// module chunks = 0 62 63